module.exports = __webpack_public_path__ + "static/media/worlds-smallest-violin.36b3219c.mp3";